import Text from "theme/Text";
import React from 'react'
import _ from 'lodash'
import i18n from 'utils/i18n'
import { ThemedSizes } from 'styles/themed'
import { bookingStatus } from 'utils/constants/booking-constants'
import EmployeeCard, { EmployeeCardModes } from 'components/molecules/EmployeeCard'
import DataItem from 'components/atoms/DataItem'
import { StyleSheet, View } from 'react-native'
import { DataItemStatusIcon } from 'components/molecules/DataItemStatus'
import HelperDate, { dateFormat } from 'utils/helper-date'

const ListItemLog = ({ item }) => {
	
	const currentDateDate = HelperDate.date().format( dateFormat.DATE )
	const { date, dateDate, dateTime, value, employee, status } = getLogValue( item )
	
	const dateItem = (
		<View style={ staticStyles.viewFlexDirectionColumnAlignItemsFlexEnd }>
			{ currentDateDate !== dateDate  && (
				<Text
					adjustsFontSizeToFit={ true }
					appearance="hint"
					category="c2"
					style={ staticStyles.textFontSize10 }>
					
					{ dateDate }
				</Text>
			)}
			
			<Text
				adjustsFontSizeToFit={ true }
				appearance="hint"
				category="c2">
				
				{ dateTime }
			</Text>
		</View>
	)
	
	return (
		<EmployeeCard
			mode={ EmployeeCardModes.listItem }
			employee={ employee }
			avatarSize={ ThemedSizes.XS }
			show={{ }}
			showHeart={ false }
			actionItem={ dateItem }>
			
			<DataItem
				icon={ <DataItemStatusIcon status={ status } /> }>
				
				{ value }
			</DataItem>
		</EmployeeCard>
	)
}

const getLogValue = ( item ) => {
	// Log specific
	const logValue = _.get( item, 'log_value', null )
	const logCreatedAt = _.get( item, 'created_at', null )
	const dateObject = HelperDate.date( logCreatedAt )
	
	// Information
	//const bookingDate = _.get( item, ['booking', 'booking_date'], null )
	const employee = _.get( item, ['booking', 'employee'], {} )
	//const timeslot = _.get( item, ['booking', 'timeslot'], {} )
	
	// transform
	let status = null;
	switch( logValue ) {
		case 'status_changed_to_invited':
			status = bookingStatus.INVITED;
			break;
			
		case 'status_changed_to_invite_accepted':
			status = bookingStatus.INVITE_ACCEPTED;
			break;
			
		case 'status_changed_to_invite_rejected':
			status = bookingStatus.INVITE_REJECTED;
			break;
			
		case 'status_changed_to_active':
			status = bookingStatus.ACTIVE;
			break;
			
		case 'status_changed_to_cancelled':
			status = bookingStatus.CANCELLED;
			break;
	}
	
	let value = null;
	if( status !== null ) {
		value = i18n.t( 'page.invitation.log.status_changed', { status: i18n.t(`page.booking.status.${status}` ).toLowerCase() } );
	}
	
	return {
		date: logCreatedAt,
		dateDate: dateObject.format( dateFormat.DATE ),
		dateTime: dateObject.format( dateFormat.SHORT_TIME ),
		value,
		employee,
		status
	}
}

const staticStyles = StyleSheet.create({
	viewFlexDirectionColumnAlignItemsFlexEnd: {
		flexDirection: 'column',
		alignItems: 'flex-end',
	},
	textFontSize10: {
		fontSize: 10,
	},
});

export default ListItemLog
